import { useState } from 'react';

export const MidRiseApartmentsFAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What qualifies as a mid-rise apartment building?',
      answer: 'Mid-rise apartment buildings typically have 4-8 stories and 30-100 units. They usually include elevator access, structured parking, and professional-grade building systems. These properties bridge the gap between low-rise walk-ups and high-rise towers.'
    },
    {
      question: 'How quickly can you close on a mid-rise property?',
      answer: 'We can typically close in 30-45 days, depending on your timeline and any title or legal issues. Our team works efficiently to complete due diligence while respecting your schedule. If you need to close faster or slower, we can accommodate your needs.'
    },
    {
      question: 'Do you buy mid-rise buildings with deferred maintenance?',
      answer: 'Yes, we specialize in purchasing properties with deferred maintenance, aging systems, and capital needs. We factor these costs into our offer and buy the property as-is. You won\'t need to make any repairs or improvements before selling.'
    },
    {
      question: 'What if my mid-rise building has below-market rents?',
      answer: 'Below-market rents are actually attractive to us as they represent upside potential. We\'ll evaluate the property based on both current income and future rent potential. You don\'t need to wait to raise rents before selling—we can close now and handle that ourselves.'
    },
    {
      question: 'Can you buy out one partner in a multi-owner situation?',
      answer: 'Yes, we can structure transactions to buy out individual partners or acquire the entire property from all owners. We have experience with partnership dissolutions, estate situations, and complex ownership structures. We\'ll work with all parties to find a fair solution.'
    },
    {
      question: 'How do you determine the value of a mid-rise property?',
      answer: 'We evaluate mid-rise properties based on multiple factors: current net operating income, rent roll analysis, property condition, location, market comparables, and future potential. We provide detailed valuations that account for both current performance and needed improvements.'
    },
    {
      question: 'Do I need to provide detailed financial records?',
      answer: 'We need basic financial information like rent rolls, operating expenses, and recent tax returns, but we don\'t require extensive documentation upfront. We can work with whatever records you have available and conduct our own analysis during due diligence.'
    },
    {
      question: 'What happens to existing tenants when you buy the property?',
      answer: 'Existing leases transfer to us at closing, and tenants remain in place. We\'re experienced property owners who maintain good tenant relationships. Your tenants will continue under their current lease terms with professional management.'
    },
    {
      question: 'Do you charge any fees or commissions?',
      answer: 'No, we don\'t charge any fees or commissions. We\'re the direct buyer, so there are no broker commissions or transaction fees. The offer we present is the amount you\'ll receive at closing, minus standard closing costs.'
    },
    {
      question: 'What markets do you buy mid-rise properties in?',
      answer: 'We purchase mid-rise apartment buildings in urban and suburban markets nationwide. We\'re particularly active in primary and secondary markets with strong fundamentals, but we\'ll consider properties in any location. Contact us to discuss your specific market.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Common questions about selling mid-rise apartment buildings to us.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 text-left flex items-center justify-between cursor-pointer hover:bg-gray-100 transition-colors"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-8">{faq.question}</h3>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-teal-500 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold mb-4 text-gray-900">Still Have Questions?</h3>
          <p className="text-gray-600 mb-6 leading-relaxed">
            We're happy to answer any questions about selling your mid-rise apartment building. Contact us for a confidential conversation.
          </p>
          <a 
            href="#get-offer" 
            className="whitespace-nowrap inline-block bg-teal-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-600 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            Contact Us Today
          </a>
        </div>
      </div>
    </section>
  );
};